import React from 'react';
import { Box, Typography, Button, IconButton, Drawer } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import SimpleContent from 'components/simpleContent';
import { getPinDomain, getPinSnippet } from '../utils/autoLayout';

const PinFocusPanel = ({ activity, open, onClose, loadedTime }) => {
  if (!activity) return null;

  const href = activity?.content?.[0]?.urls?.[0]?.href;

  return (
    <Drawer anchor="right" open={open} onClose={onClose} PaperProps={{ sx: { width: { xs: '100%', sm: 420 } } }}>
      <Box sx={{ p: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between', borderBottom: '1px solid #eee' }}>
        <Box>
          <Typography variant="subtitle2" color="text.secondary">
            {getPinDomain(activity)}
          </Typography>
          <Typography variant="body2" sx={{ mt: 0.5 }}>
            {getPinSnippet(activity) || 'Pin details'}
          </Typography>
        </Box>
        <IconButton onClick={onClose} aria-label="Close">
          <CloseIcon />
        </IconButton>
      </Box>
      <Box sx={{ p: 2, overflow: 'auto' }}>
        {activity.content?.[0] ? (
          <SimpleContent type="FEED" activity={activity} isBookmarkLayout loadedTime={loadedTime} />
        ) : null}
        {href ? (
          <Button
            fullWidth
            variant="outlined"
            startIcon={<OpenInNewIcon />}
            sx={{ mt: 2 }}
            onClick={() => window.open(href, '_blank', 'noopener,noreferrer')}
          >
            Open source page
          </Button>
        ) : null}
      </Box>
    </Drawer>
  );
};

export default PinFocusPanel;
